export const styleHookMapping = {
  inputValue: () => null,
  value: () => null
};